export default __webpack_public_path__ + "media/images/facebook-header-social-218c16f3e5d699a8423832a119bda14b.svg";